import { ConfirmSetForm } from '../confirm-set-form/confirm-set-form';

export const StayCloseSetForm = (props) => {
  const { close, action, working } = props;

  const title = 'Закрыть выбранные парковки?';

  const params = {
    title,
    close,
    action,
    working,
  };

  return <ConfirmSetForm {...params} />;
};
